class QueueWarningModal extends Modal {
    constructor() {
        super();
        this.continueButton = this.querySelector('[data-continue]');
        this.saveButton = this.querySelector('[data-save]');
        this.abortButton = this.querySelector('[data-abort]');
    }

    connectedCallback() {
        this.continueButton.addEventListener('click', this.handleContinue.bind(this));
        this.saveButton.addEventListener('click', this.handleSave.bind(this));
        this.abortButton.addEventListener('click', this.handleAbort.bind(this));
    }

    disconnectedCallback() {
        this.continueButton.removeEventlistener('click', this.handleContinue.bind(this));
        this.saveButton.removeEventlistener('click', this.handleSave.bind(this));
        this.abortButton.removeEventlistener('click', this.handleAbort.bind(this));
    }

    buttonState(state) {
        this.continueButton.disabled = state;
        this.saveButton.disabled = state;
        this.abortButton.disabled = state;
    }

    async handleContinue() {
        this.buttonState(true);
        this.continueButton.classList.add('is-loading');
        localStorage.setItem('queue', '[]');
        document.dispatchEvent(new CustomEvent('queue-job:hide', { bubbles: true }));
        await this.handleUserNameChange();
        this.close(this);
        this.buttonState(false);
        this.continueButton.classList.remove('is-loading');
    }

    async handleSave() {
        this.buttonState(true);
        this.saveButton.classList.add('is-loading');
        localStorage.setItem('queue', '[]');
        
        console.log('🚫 DEPRECATED: window.notifyBackend() call replaced with webhook approach');
        
        // Set user cart attributes for webhook identification instead of direct API call
        if (window.sharedCartService && window.sharedCartService.setUserCartAttributes) {
            await window.sharedCartService.setUserCartAttributes();
            console.log('✅ Cart attributes updated for webhook processing');
        }
        
        document.dispatchEvent(new CustomEvent('queue-job:hide', { bubbles: true }));
        await this.handleUserNameChange();
        this.close(this);
        this.buttonState(false);
        this.saveButton.classList.remove('is-loading');
    }

    async handleAbort() {
        this.buttonState(true);
        this.abortButton.classList.add('is-loading');
        document.querySelector('select[name="new_user_number"]').selectedIndex = document.querySelector(`select[name="new_user_number"] option[value="${window.customer.currentUserNumber}"]`).index;
        window.fetchQueue.pause = false;
        this.close(this);
        this.buttonState(false);
        this.abortButton.classList.remove('is-loading');
    }

    async handleUserNameChange() {
        const userNumberChangeForm = document.querySelector(`form[is="${UserNumberUpdateForm.elementName}"]`);
        await userNumberChangeForm.handleUpdateUserNumber(true);
        await userNumberChangeForm.awaitUserNumberChange();
        if (window.customer && !document.querySelector('main-calendar').selectedDate && window.rebuild == false) {
            document.documentElement.dispatchEvent(new Event("main-calendar:on:open", { bubbles: true }));
            return;
        }
        location.reload();
    }

    open(evt) {
        window.fetchQueue.pause = true;
        document.querySelector(HeaderMenu.elementName).toggleOpen(this);
        super.open(evt);
    }

    close(evt) {
        if (evt == undefined) return;
        super.close(evt);
    }
}

customElements.define('queue-warning-modal', QueueWarningModal);